import React from "react";
import { Button } from "aible";

import Select from "react-select";
import styles from "./style.module.css";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class AssignTodoModal extends React.Component {
  constructor(props) {
    super(props);
    const { todo } = this.props;

    this.state = {
      title: todo?.title || "",
      subTitle: todo?.subTitle || "",
      textBody: todo?.textBody || "",
      cHoursAgo: todo?.cHoursAgo || 0,
      contractType: todo?.contractType || "",
      contractLength: todo?.contractLength || "",
      budget: 120,
      maxBudget: 500,
      rateType: todo?.rateType || "Per Hour",
      assignee: "Jane C."
    };
  }

  componentDidUpdate(prevProps) {
    const { todo } = this.props;

    if (todo !== undefined && prevProps.todo === undefined) {
      this.setState({
        id: todo.id,
        nextId: todo.nextId,
        title: todo.title,
        subTitle: todo.subTitle,
        textBody: todo.textBody,
        cHoursAgo: todo.cHoursAgo,
        contractType: todo.contractType,
        contractLength: todo.contractLength,
        rateType: todo.rateType,
        assignee: todo.assignee,
        node: todo.node
      });
    }
  }

  render() {
    const { createTodo, assignTodo, todo, users, activeSegment, project } = this.props;

    const { id, textBody, assignee } = this.state;

    const assignOptions =
      users === undefined
        ? []
        : users.map((u) => ({
            label: u.fullname,
            value: u.fullname,
            id: u.id
          }));

    const subgroup = activeSegment?.conditions?.[0]?.value || "Overall";
    const hasSubgroups = project?.segments && project.segments.length > 1;

    return (
      <div id={"todoModal"}>
        <Dialog ope={todo !== undefined} onOpenChange={() => assignTodo(undefined)}>
          <DialogContent size="xl">
            <DialogHeader>
              <DialogTitle>
                {todo?.node?.isDashboard ? "Sharing Dashboard" : "Assign Task: " + todo?.node?.text}
              </DialogTitle>
            </DialogHeader>
            <div className={styles.modalBody}>
              <div className={styles.modalFull}>
                {hasSubgroups && (
                  <div className={styles.jobInput}>
                    <div className={styles.bTitle}>{"Subgroup: " + subgroup}</div>
                  </div>
                )}
                <div className={styles.jobInput}>
                  <div className={styles.bTitle}>
                    {todo?.node?.isDashboard
                      ? "Who do you want to share this Dashboard with? "
                      : "Who do you want to assign this task to? "}
                  </div>
                  <Select
                    options={assignOptions}
                    value={assignOptions.find((a) => a.value === assignee)}
                    onChange={(val) =>
                      this.setState({
                        assignee: val.value,
                        assigneeId: val.id
                      })
                    }
                  />
                </div>
                <div className={styles.jobInput}>
                  <div className={styles.bTitle}>
                    {todo?.node?.isDashboard ? "Dashboard Description" : "Automated Job Description: "}
                  </div>
                  <div className={styles.todoRight}>
                    <textarea
                      className={styles.jobDescription}
                      onChange={(e) => this.setState({ textBody: e.target.value })}
                      value={textBody}
                    />
                  </div>
                </div>
              </div>
            </div>
            <DialogFooter>
              <Button type="secondary" onClick={() => assignTodo(undefined)} style={{ marginRight: "auto" }}>
                {"Close"}
              </Button>
              <Button type="primary" onClick={() => createTodo({ ...this.state })}>
                {id !== undefined ? "Update" : "Assign"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}
